import { css } from "@emotion/react"
import styled from "@emotion/styled"

const dinamicStyles = ({ theme, lowerText }) => css`
  ${lowerText &&
  `
    ${theme.breakpoints.down("xl")} {
      margin-bottom: 79px; 
    }

    ${theme.breakpoints.between("xl", "2xl")} {
      margin-bottom: 94px;  
    }

    ${theme.breakpoints.up("2xl")} {
      margin-bottom: 137px;  
    }
  `}
`

const ListSixteenStack = styled.ul`
  padding: 0;
  list-style-type: none;
  margin-right: auto;
  margin-left: auto;
  ${dinamicStyles}

  ${({ theme }) => theme.breakpoints.up("md")} {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  ${({ theme }) => theme.breakpoints.between("md", "lg")} {
    gap: 10px;
  }

  ${({ theme }) => theme.breakpoints.between("lg", "xl")} {
    gap: 17px;
  }

  ${({ theme }) => theme.breakpoints.between("xl", "2xl")} {
    gap: 27px;
  }
  ${({ theme }) => theme.breakpoints.up("2xl")} {
    gap: 35px;
  }
`

export default ListSixteenStack
